import CredentialIntake from './credentialIntake';

export default CredentialIntake;
